import { render, staticRenderFns } from "./QuizManagement.vue?vue&type=template&id=27b9cdda&scoped=true&"
import script from "./QuizManagement.vue?vue&type=script&lang=js&"
export * from "./QuizManagement.vue?vue&type=script&lang=js&"
import style0 from "./QuizManagement.vue?vue&type=style&index=0&id=27b9cdda&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b9cdda",
  null
  
)

export default component.exports